import React from 'react';
import Button from '@atlaskit/button/new';
import { useIntl } from '@atlassian/jira-intl';
import { useActions } from '../services/index.tsx';
import type { TaskId } from '../tasks/constants.tsx';
import messages from './TaskCompleteButton.messages.tsx';

const TaskCompleteButton = ({ taskId }: { taskId: TaskId }): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const { completeTaskAndContinue } = useActions();

	return (
		<Button appearance="discovery" onClick={() => completeTaskAndContinue({ id: taskId })}>
			{formatMessage(messages.completeButton)}
		</Button>
	);
};

export default TaskCompleteButton;
